import { createStyles, makeStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";

const style = createStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    padding: "32px",
    marginTop: 64,
  },
  tabPanelRoot: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-evenly",
  },
});

export const styles = (theme: Theme) => createStyles(style);
export const useStyles = makeStyles(style);
